import { httpClient } from './httpClient';

export interface TagTitleSuggestion {
  id: number;
  tag_id: number;
  title: string;
  usage_count: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  tag_name?: string;
}

export const tagTitleSuggestionService = {
  /**
   * Get all title suggestions for admin
   */
  getAllTitleSuggestions: async (): Promise<TagTitleSuggestion[]> => {
    try {
      return await httpClient.get<TagTitleSuggestion[]>('/api/tag-title-suggestions/all');
    } catch (error) {
      console.error('Error fetching all title suggestions:', error);
      return [];
    }
  },

  /**
   * Get title suggestions for a specific tag
   */
  getTitlesByTagId: async (tagId: number): Promise<TagTitleSuggestion[]> => {
    try {
      return await httpClient.get<TagTitleSuggestion[]>(`/api/tag-title-suggestions/tag/${tagId}`);
    } catch (error) {
      console.error('Error fetching title suggestions for tag:', error);
      return [];
    }
  },

  /**
   * Get title suggestions for multiple tags
   */
  getTitlesByTagIds: async (tagIds: number[]): Promise<TagTitleSuggestion[]> => {
    try {
      if (!tagIds || tagIds.length === 0) {
        return [];
      }
      return await httpClient.post<TagTitleSuggestion[]>('/api/tag-title-suggestions/by-tags', { tagIds });
    } catch (error) {
      console.error('Error fetching title suggestions for tags:', error);
      return [];
    }
  },

  /**
   * Create a new title suggestion for a tag
   */
  createTitleSuggestion: async (tagId: number, title: string): Promise<TagTitleSuggestion | null> => {
    try {
      return await httpClient.post<TagTitleSuggestion>(`/api/tag-title-suggestions/tag/${tagId}`, { title });
    } catch (error) {
      console.error('Error creating title suggestion:', error);
      return null;
    }
  },

  /**
   * Update a title suggestion
   */
  updateTitleSuggestion: async (id: number, title: string): Promise<TagTitleSuggestion | null> => {
    try {
      return await httpClient.put<TagTitleSuggestion>(`/api/tag-title-suggestions/${id}`, { title });
    } catch (error) {
      console.error('Error updating title suggestion:', error);
      return null;
    }
  },

  /**
   * Delete a title suggestion
   */
  deleteTitleSuggestion: async (id: number): Promise<boolean> => {
    try {
      await httpClient.delete(`/api/tag-title-suggestions/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting title suggestion:', error);
      return false;
    }
  },

  /**
   * Increment usage count for a title suggestion
   */
  incrementUsageCount: async (id: number): Promise<boolean> => {
    try {
      await httpClient.post(`/api/tag-title-suggestions/${id}/usage`, {});
      return true;
    } catch (error) {
      console.error('Error incrementing usage count:', error);
      return false;
    }
  }
};
